import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import SC_ManageData from '../../SC_ManageData';
import { RootState } from '../../../../redux/checkoutredux/store/checkoutStore';

const BlockFooterV2: React.FC = () => {
  const settings = useSelector((state: RootState) => state.sidecartsettings.appSettings || {});
  const metacartdata = useSelector((state: RootState) => state.shoppingcart.metacartdata || []);
  const notices = useSelector((state: RootState) => state.shoppingcart.noticedata || {});

  const [totalformat, setTotalFormat] = useState<string>('');

  useEffect(() => {
    if (metacartdata.length > 0) {
      setTotalFormat(metacartdata[0]?.totalpriceformat || '');
    }
  }, [metacartdata]);

  const getRelativeShoppingCartURL = (): string => {
    return settings.cart_url || '';
  };

  const typeClassMapping = {
    error: 'ips-alert-error',
    notice: 'ips-alert-info',
    success: 'ips-alert-success',
  };

  const shouldSetInputOrderbump = (orderbump: any) => {
    if (orderbump) {
      const doOrderbump = SC_ManageData.validateOrderbump(orderbump);
      if (doOrderbump) {
        const postID = parseInt(orderbump[0]['ips-mb-ordebumps-metadata-orderbump-postid'], 10);
        return <input type="hidden" name="ips_displayed_order_bump[]" value={postID} />;
      }
    }
    return null;
  };

  const buttonToShoppingCart = () => {
    return (
      <form action={getRelativeShoppingCartURL()} method="POST">
        {settings.orderbumpsoptions?.map(shouldSetInputOrderbump)}
        <button type="submit" className="ips-sidecart-primary-btn ips-sidecart-checkout-btn">
          WARENKORB ANZEIGEN
        </button>
      </form>
    );
  };

  return (
    <div className="row p-2 mx-0 ips-sidecart-elementfooter">
      <div className="ips-sidecart-footer">
        <div className="col-12 p-0" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div className="row p-0 flex-grow-1">
            <div id="ips-alert-placeholder">
              <div className="ips-alert">
                <div className="message"></div>
              </div>
            </div>

            <div id="ips-alert-container" className="woocommerce-notices-wrapper">
              {notices &&
                Object.entries(notices).map(([type, messages]) =>
                  Array.isArray(messages) &&
                  messages.map((message, index) => {
                    const noticeText = message.notice_message || message;
                    const alertId = `${noticeText}${typeClassMapping[type]}${type}${index}`;
                    return (
                      <div key={alertId} className={`ips-alert ${typeClassMapping[type]}`}>
                        <div className="message">{noticeText}</div>
                      </div>
                    );
                  })
                )}
            </div>
          </div>
          <div className="row p-2 flex-grow-0">
            <div className="col-6 p-0">Zwischensumme:</div>
            <div className="col-3 p-0"></div>
            <div
              className="col-3 p-0 text-center"
              dangerouslySetInnerHTML={{ __html: totalformat || '' }}
            ></div>
          </div>
          <div className="row g-0 p-0 flex-grow-0">
            <div className="ips-proceed-to-checkout">{buttonToShoppingCart()}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockFooterV2;